import { render, staticRenderFns } from "./articleView.vue?vue&type=template&id=597c85fe&scoped=true&"
import script from "./articleView.vue?vue&type=script&lang=js&"
export * from "./articleView.vue?vue&type=script&lang=js&"
import style0 from "./articleView.vue?vue&type=style&index=0&id=597c85fe&prod&scoped=true&lang=css&"
import style1 from "./articleView.vue?vue&type=style&index=1&id=597c85fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597c85fe",
  null
  
)

export default component.exports